import React from 'react'

import { GreyBase } from '../../const/colors'
import { IIcons } from './types'

export default (props: IIcons) => {
  const { style, fill = GreyBase } = props
  const defaultStyle = { width: 18, height: 18 }

  return (
    <svg style={{ ...defaultStyle, ...style }} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.4771 6.45646L11.9596 7.81589C11.3466 8.3656 10.8505 8.80983 10.4117 9.11291C9.95559 9.42863 9.51126 9.62772 8.99921 9.62772C8.48716 9.62772 8.04282 9.42789 7.58605 9.11291C7.14794 8.80983 6.65178 8.36486 6.03884 7.81663L4.52064 6.4572M7.57776 2.5H10.4193C11.6894 2.5 12.6955 2.5 13.4826 2.61366C14.2925 2.73103 14.9483 2.97766 15.4659 3.53331C15.9828 4.08971 16.2122 4.79469 16.3214 5.66531C16.4271 6.51217 16.4271 7.59303 16.4271 8.9584V9.0416C16.4271 10.407 16.4271 11.4886 16.3214 12.3347C16.2122 13.2053 15.9828 13.9103 15.4659 14.4667C14.9483 15.0223 14.2925 15.269 13.4826 15.3863C12.6948 15.5 11.6894 15.5 10.4193 15.5H7.57776C6.30765 15.5 5.30151 15.5 4.51442 15.3863C3.70454 15.269 3.04875 15.0223 2.53117 14.4667C2.01428 13.9103 1.78486 13.2053 1.67567 12.3347C1.56995 11.4878 1.56995 10.407 1.56995 9.0416V8.9584C1.56995 7.59303 1.56995 6.51143 1.67567 5.66531C1.78486 4.79469 2.01428 4.08971 2.53117 3.53331C3.04875 2.97766 3.70454 2.73103 4.51442 2.61366C5.3022 2.5 6.30765 2.5 7.57776 2.5Z"
        stroke={fill}
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  )
}
